<template lang="pug">
  .tabs.is-flex-shrink-0(style="margin-bottom: 0")
    ul
      li(v-for="tab in visibleTabs" :class="{'is-active': $route.path === tab.path}" :data-qa="tab['data-qa']")
        router-link(:to='tab.path' v-if="!tab.product || $rfSubscribed(tab.product)")
          span.icon
            i.mdi(aria-hidden="true" :class="`mdi-${tab.icon}`")
          span(v-t="tab.title")
        a(v-else)
          span.icon
            i.mdi(aria-hidden="true" :class="`mdi-${tab.icon}`")
          span(v-t="tab.title")
          span.icon.has-text-primary
            i.mdi.mdi-lock-outline
</template>
<script>
import {mapState} from 'vuex'
export default {
  name: 'NavigationTabs',
  props: {
    tabs: {type: Array, required: true}
  },
  computed: {
    ...mapState('auth', ['user']),
    visibleTabs() {
      return this.tabs.filter(tab => {
        return (
          (!tab.permission || this.$rfHasPermission(tab.permission)) &&
          (!tab.product || this.$rfEnabled(tab.product)) &&
          !tab.hidden
        )
      })
    }
  }
}
</script>
